import { useMediaQuery } from "./use-media-query";

export function useIsOSThemeDark() {
    return useMediaQuery("(prefers-color-scheme: dark)");
}
